import React from 'react';
import { IconButton, PopoverMenu } from '@guildeducationinc/recess';
import MoreVertIcon from '@guildeducationinc/recess/icons/MoreVertIcon';
import { clickable } from '@src/analytics';
import { openNextStepsMicrositeForInstitution } from '@src/utilities/nextStepsUtility';
import { GENESIS_URL } from '@src/constants';

interface PopoverActionProps {
  academicPartnerUuid: string;
  applicationId: string;
  product: string;
  programId: string;
  status: string;
}

export const PopoverAction: React.FC<PopoverActionProps> = ({
  academicPartnerUuid,
  applicationId,
  product,
  programId,
  status,
}) => {
  const tagStatus = status === 'completed' ? 'submitted' : status;

  return (
    <PopoverMenu
      id={`application-actions-${applicationId}`}
      testid='applicationActions'
      actions={[
        {
          name: 'See application',
          href: `${GENESIS_URL}/applications/${applicationId}`,
          onClick: () => {
            clickable({
              applicationId: parseInt(applicationId),
              loggedIn: true,
              offeringId: programId,
              product,
              tag: `applications_${tagStatus}_popover`,
              text: 'see_application',
              type: 'link',
            });
          },
          type: 'link' as const,
        },
        {
          name: 'See next steps',
          onClick: () => {
            clickable({
              applicationId: parseInt(applicationId),
              loggedIn: true,
              product,
              offeringId: programId,
              tag: `applications_${tagStatus}_popover`,
              text: 'see_next_steps',
              type: 'link',
            });
            openNextStepsMicrositeForInstitution(academicPartnerUuid);
          },
          type: 'action' as const,
        },
      ]}
    >
      <IconButton
        appearance='ghost'
        className='applicationCardPopoverIcon flexSelf--center'
        icon={<MoreVertIcon size={32} />}
        label='Options'
        onClick={() => {
          clickable({
            applicationId: parseInt(applicationId),
            loggedIn: true,
            offeringId: programId,
            product,
            tag: `applications_${tagStatus}_popover`,
            text: 'open_popover',
            type: 'button',
          });
        }}
      />
    </PopoverMenu>
  );
};
